export const cardProduct = ({ baseUrl, shortDesc, showDiameter, variantsData }) => ({
	baseUrl,
	shortDesc,
	showDiameter,
	variants: variantsData || [],
	selectedColour: null,
	selectedSize: null,
	selectedSizeType: null,
	selectedVariant: null,
	currentUrl: baseUrl,
	currentImage: null,

	init() {
		if (!this.variants.length) {
			this.currentUrl = this.baseUrl
			return
		}

		const firstVariant = this.variants[0]
		this.selectedColour = this.normalizeColour(firstVariant.colour)
		this.selectedSize = firstVariant.size || null

		this.mapToAvailableVariant()
		this.updateCardState()
	},

	get colours() {
		const seen = new Set()

		return this.variants
			.map(variant => variant.colour)
			.filter(colour => {
				if (!colour || !colour.id) return false
				if (seen.has(colour.id)) return false
				seen.add(colour.id)
				return true
			})
	},

	get sizeOptions() {
		if (!this.variants) return []

		const seen = new Map()

		return this.variants
			.map(variant => {
				const sizeType = typeof variant.sizeType === 'string'
					? variant.sizeType
					: (variant.sizeType?.label || null)

				return {
					size: variant.size,
					sizeType,
				}
			})
			.filter(option => {
				if (!option.size) return false
				const sizeKey = option.size
				const typeKey = option.sizeType || null

				if (!seen.has(sizeKey)) {
					seen.set(sizeKey, new Set())
				}

				const typeSet = seen.get(sizeKey)
				if (typeSet.has(typeKey)) return false
				typeSet.add(typeKey)
				return true
			})
			.sort((a, b) => {
				const aNumber = parseInt(String(a.size).match(/\d+/)?.[0] ?? '0', 10)
				const bNumber = parseInt(String(b.size).match(/\d+/)?.[0] ?? '0', 10)
				return aNumber - bNumber
			})
	},

	selectColour(colour) {
		this.selectedColour = this.normalizeColour(colour)
		this.mapToAvailableVariant()
		this.updateCardState()

		window.dispatchEvent(new CustomEvent('cardProductColourUpdate'))
	},

	selectSize(size, sizeType) {
		this.selectedSize = size
		this.selectedSizeType = sizeType
		this.mapToAvailableVariant()
		this.updateCardState()
	},

	sizeIsAvailable(size) {
		return !!this.findVariantFor(this.selectedColour, size)
	},

	mapToAvailableVariant() {
		if (!this.variants.length) {
			this.selectedVariant = null
			return
		}

		let variant = this.findVariantFor(this.selectedColour, this.selectedSize)

		if (!variant) {
			variant = this.findVariantFor(this.selectedColour, null)
		}

		if (!variant) {
			variant = this.findVariantFor(null, this.selectedSize)
		}

		if (!variant) {
			variant = this.variants[0]
		}

		if (!variant) {
			this.selectedVariant = null
			return
		}

		this.selectedVariant = variant
		this.selectedColour = this.normalizeColour(variant.colour)
		this.selectedSize = variant.size || null
	},

	findVariantFor(colour, size) {
		const colourTitle = this.normalizeColour(colour)

		return this.variants.find(variant => {
			if (colourTitle && this.normalizeColour(variant.colour) !== colourTitle) return false
			if (size && variant.size !== size) return false
			return true
		}) || null
	},

	normalizeColour(colour) {
		if (!colour) return null
		if (typeof colour === 'string') return colour
		return colour.title || null
	},

	updateCardState() {
		if (!this.selectedVariant) {
			this.currentImage = null
			this.currentUrl = this.baseUrl
			return
		}

		this.currentImage = this.selectedVariant.image || null
		this.currentUrl = this.buildVariantUrl(this.selectedVariant.id)
	},

	buildVariantUrl(variantId) {
		try {
			const url = new URL(this.baseUrl, window.location.origin)
			url.searchParams.set('variant', variantId)
			return url.pathname + url.search + url.hash
		} catch (_err) {
			if (!variantId) return this.baseUrl
			const separator = this.baseUrl.includes('?') ? '&' : '?'
			return `${this.baseUrl}${separator}variant=${variantId}`
		}
	},
})
